import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpHeaders, HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ProductsDaoService {

  private BASE_URL = environment.apiURL;
  private OPTIONS = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json; charset=UTF-8'
    })
  };

  constructor(private http: HttpClient) { }

  public getProductsCounts(context, lang, udid) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    return this.http.get(this.BASE_URL + 'private/v2.0/product/count', options);
  }

  public getProductsList(context, lang, udid) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    return this.http.get(this.BASE_URL + 'private/v2.0/product/all', options);
  }

  public getProductInfo(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    options['params'] = { internalId };
    return this.http.get(this.BASE_URL + 'private/v2.0/product', options);
  }

  public addNewProduct(context, lang, udid, active, gtin, description, internalCode, tradename, category, categoryCode, additionalInfo, measure, measureUnit, pricePVP, pricePVPOffer, taxAmount, image, preparations) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { active, gtin, description, internalCode, tradename, category, categoryCode, additionalInfo, measure, measureUnit, pricePVP, pricePVPOffer, taxAmount, image, preparations };
    return this.http.post(this.BASE_URL + 'private/v2.0/product', item, options);
  }

  public updateProductImage(context, lang, udid, internalId, image) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, image };
    return this.http.patch(this.BASE_URL + 'private/v2.0/product', item, options);
  }

  public updateProductInfo(context, lang, udid, internalId, active, gtin, internalCode, description, tradename, category, categoryCode, additionalInfo) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, active, gtin, internalCode, description, tradename, category, categoryCode, additionalInfo };
    return this.http.patch(this.BASE_URL + 'private/v2.0/product', item, options);
  }

  public updateProductPrices(context, lang, udid, internalId, measure, measureUnit, pricePVP, pricePVPOffer, taxAmount) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, measure, measureUnit, pricePVP, pricePVPOffer, taxAmount };
    return this.http.patch(this.BASE_URL + 'private/v2.0/product', item, options);
  }

  public updateProductPreparations(context, lang, udid, product, internalIds) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { product, internalIds };
    return this.http.patch(this.BASE_URL + 'private/v2.0/product/preparations', item, options);
  }

  public deleteProducts(context, lang, udid, internalIds) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    options['body'] = { internalIds };
    return this.http.request('delete', this.BASE_URL + 'private/v2.0/product', options);
  }
}
